import { MoneyType, VenueSurchargesType } from '@api';
import {
  formatCurrency,
  getValueByPath,
  TouringCardTableRow,
  TouringCardTableRowLabel,
  TouringCardTableRowValue,
} from '@common';
import { useTranslation } from 'react-i18next';
import { VenueSurchargesTableRowType } from '../../data';

type VenueSurchargesTableRowPropsType = {
  venueSurcharges: VenueSurchargesType;
  row: VenueSurchargesTableRowType;
};
export const VenueSurchargesTableRow: React.FC<VenueSurchargesTableRowPropsType> = ({
  venueSurcharges,
  row,
}) => {
  const { t } = useTranslation('venueDetailsOverview');

  const label = t(`VENUE_SURCHARGES.ROWS.${row.label}`);
  const value = getValueByPath(venueSurcharges, row.accessor);

  const getRenderValue = () => {
    if (!value) return t('NO_DATA_PLACEHOLDER', { ns: 'common' });

    switch (row.accessor) {
      case 'facilityFee':
      case 'publicTransportFee':
        return formatCurrency(value as MoneyType);
      case 'notes':
        return String(value);
    }
  };
  return (
    <TouringCardTableRow>
      <TouringCardTableRowLabel>{label}</TouringCardTableRowLabel>
      <TouringCardTableRowValue>{getRenderValue()}</TouringCardTableRowValue>
    </TouringCardTableRow>
  );
};

